import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import FormElement from "@/components/Form/FormElement.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormConditional',
    props: {
        step: null
    },
    emits: ["onUpdateStep"],
    setup(__props, { emit }) {
        const props = __props;
        const conditionalDefined = computed(() => {
            return Boolean(props.step.when);
        });
        function onSkipBoolean(value) {
            if (props.step.when && value === false) {
                emit("onUpdateStep", props.step.id, { when: undefined });
            }
            else if (value === true && !props.step.when) {
                const when = "$(inputs.when)";
                const newStep = {
                    when,
                    input_connections: { ...props.step.input_connections, when: undefined },
                };
                emit("onUpdateStep", props.step.id, newStep);
            }
        }
        return { __sfc: true, emit, props, conditionalDefined, onSkipBoolean, FormElement };
    }
});
